import { SITE } from "./site";

// React 19 automatically hoists <title>, <meta>, <link>, <script> to <head>.
export default function Seo({ title, description, path = "/", image, type = "website", jsonLd = [] }) {
  const url = `${SITE.domain}${path}`;
  const ogImage = image || `${SITE.domain}/og-default.jpg`;
  const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={SITE.legal} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </>
  );
}

export const orgLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE.legal,
  url: SITE.domain,
  email: SITE.email,
  telephone: SITE.phone,
  address: { "@type": "PostalAddress", streetAddress: "Sharjah Media City", addressLocality: "Sharjah", addressCountry: "AE" },
};

export const localBusinessLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: SITE.legal,
  image: `${SITE.domain}/og-default.jpg`,
  url: SITE.domain,
  telephone: SITE.phone,
  email: SITE.email,
  address: { "@type": "PostalAddress", streetAddress: "Sharjah Media City", addressLocality: "Sharjah", addressCountry: "AE" },
  areaServed: ["Sharjah", "Dubai", "Abu Dhabi", "Ajman", "Ras Al Khaimah", "Fujairah", "Umm Al Quwain", "Al Ain"],
};

export const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE.legal,
  url: SITE.domain,
};

export function breadcrumbLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: `${SITE.domain}${it.path}` })),
  };
}

export function faqLd(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
  };
}
